import { CORREO_SOPORTE, RESPONSABLE } from "@/legal/aviso";
import { Logo } from "@/components/layout/Logo";

/**
 * Términos de uso — BORRADOR v1 (2026-10-v1) para revisión de Pili y abogado. Se aceptan junto con el aviso de privacidad
 * en la pantalla de consentimiento (misma versión en `consents`).
 */
export function Terminos() {
  return (
    <main className="mx-auto max-w-2xl px-4 py-8 text-[15px] leading-relaxed text-tinta">
      <Logo tono="claro" />
      <h1 className="mt-6 text-2xl font-semibold">Términos de uso · Wealth Nation · Tu diseño patrimonial</h1>
      <p className="mt-1 text-sm text-tinta-suave">Versión 2026-10-v1 · borrador en revisión legal</p>

      <h2 className="mt-8 text-lg font-semibold">1. Quién ofrece la herramienta</h2>
      <p><b>{RESPONSABLE}</b> ("Revolution") pone esta aplicación a disposición de los miembros activos de Wealth Nation como parte de su membresía. Al entrar y aceptar, estás de acuerdo con estos términos y con el <a className="underline" href="/aviso-de-privacidad">aviso de privacidad</a>.</p>

      <h2 className="mt-6 text-lg font-semibold">2. Qué es y qué no es</h2>
      <p>Es una herramienta <b>educativa</b> de diseño patrimonial: calcula tu foto financiera con el método del programa y te ayuda a entenderla con un asesor de inteligencia artificial. <b>No es asesoría</b> de inversiones, fiscal, contable, legal ni de seguros, ni una recomendación, oferta o solicitud para comprar o vender valores u otros instrumentos. Cualquier ejemplo de instrumento es ilustrativo; revisa tus decisiones con tu asesor.</p>

      <h2 className="mt-6 text-lg font-semibold">3. Tus decisiones son tuyas</h2>
      <p>Los resultados dependen de los datos que tú capturas y de supuestos del programa. La inteligencia artificial puede equivocarse: verifica cualquier cifra antes de decidir. Revolution no garantiza resultados, rendimientos ni el logro de tus objetivos, y no responde por decisiones que tomes con base en la herramienta.</p>

      <h2 className="mt-6 text-lg font-semibold">4. Tu cuenta</h2>
      <ul className="list-disc pl-5">
        <li>El acceso es personal e intransferible y está ligado al correo con el que estás en Wealth Nation.</li>
        <li>Eres responsable de la veracidad de lo que capturas y de no compartir tus códigos de acceso.</li>
        <li>Puedes descargar o borrar tus datos en cualquier momento desde "Cuenta".</li>
      </ul>

      <h2 className="mt-6 text-lg font-semibold">5. Uso aceptable</h2>
      <p>No uses la herramienta para fines ilícitos, para intentar acceder a datos de otras personas, para extraer de forma automatizada su contenido o para saturarla. Hay límites de uso del asesor y de los reportes para que funcione bien para todos.</p>

      <h2 className="mt-6 text-lg font-semibold">6. Disponibilidad y cambios</h2>
      <p>La herramienta puede cambiar, mejorar o pausarse temporalmente. Si dejas de ser miembro de Wealth Nation, tu acceso termina y tus datos se tratan como dice el aviso de privacidad. Si cambiamos estos términos, te pediremos aceptarlos de nuevo al entrar.</p>

      <h2 className="mt-6 text-lg font-semibold">7. Propiedad intelectual</h2>
      <p>El método, los textos, la marca y el software son de Revolution. Tus datos son tuyos.</p>

      <h2 className="mt-6 text-lg font-semibold">8. Contacto y ley aplicable</h2>
      <p>Dudas: <b>{CORREO_SOPORTE}</b>. Estos términos se rigen por las leyes de México; para cualquier controversia, las partes se someten a los tribunales competentes de la Ciudad de México.</p>

      <p className="mt-8 text-sm text-tinta-suave">Última actualización: 26 de octubre de 2026.</p>
    </main>
  );
}
